export const environment = {
  production: true,
  staging: true,
  livee: {
    url: 'http://new.livee.com/app/',
    tag: 'https://staging.livee.com',
    short: 'https://eva.staging.livee.io/'
  },
  translations: {
    key: 'lang',
    baseUrl: '//translations.livee.com/api',
    default: 'french'
  },
  auth: {
    url: '//eva.staging.livee.com/auth-service',
    redirect: '//eva.staging.livee.com/login/check'
  },
  sessions: {
    url: '//eva.staging.livee.com/sessions-service',
    links: {
      vod: [],
      video: [
        {
          name: 'sessions.details.links.general',
          color: 'warning',
          values: ['moderator', 'guest', 'videoOperator', 'powerUser', 'visitor']
        }
      ],
      mixte: [
        {
          name: 'sessions.details.links.general',
          color: 'warning',
          values: ['moderator', 'guest', 'videoOperator', 'powerUser', 'visitor']
        },
        {
          name: 'sessions.details.links.wall',
          color: 'info',
          values: [
            'Wall-01-ModerationBanner',
            'Wall-02-ModerationBanner-Bubble',
            'Wall-03-AnimationBanner',
            'Wall-04-AnimationBanner-ModerationBanner',
            'Wall-05-Bubble',
            'Wall-06.1-ModerationQuestionsList',
            'Wall-08.1-TagCloud',
            'Wall-09.1-Bubble_ModerationQuestionsList',
            'Wall-Vote1-Histogram_Pie',
            'Wall-Vote3-Podium'
          ]
        },
        {
          name: 'sessions.details.links.webapp',
          color: 'danger',
          values: [
            'WebApp-D06-TagCloud',
            'WebApp-D08-Questions_MessagesDisplay',
            'WebApp-D12-VoteQuiz',
            'WebApp-S01-Home'
          ]
        }
      ],
      interactive: [
        {
          name: 'sessions.details.links.general',
          color: 'warning',
          values: ['moderator', 'guest', 'videoOperator', 'powerUser', 'visitor']
        },
        {
          name: 'sessions.details.links.wall',
          color: 'info',
          values: [
            'Wall-01-ModerationBanner',
            'Wall-02-ModerationBanner-Bubble',
            'Wall-03-AnimationBanner',
            'Wall-04-AnimationBanner-ModerationBanner',
            'Wall-05-Bubble',
            'Wall-06.1-ModerationQuestionsList',
            'Wall-08.1-TagCloud',
            'Wall-09.1-Bubble_ModerationQuestionsList',
            'Wall-10-Clapometer',
            'Wall-Vote1-Histogram_Pie',
            'Wall-Vote3-Podium'
          ]
        },
        {
          name: 'sessions.details.links.webapp',
          color: 'danger',
          values: [
            'WebApp-D06-TagCloud',
            'WebApp-D08-Questions_MessagesDisplay',
            'WebApp-D12-VoteQuiz',
            'WebApp-D14-Clapometer',
            'WebApp-S01-Home'
          ]
        }
      ]
    }
  },
  plugins: {
    url: '//eva.staging.livee.com/plugins-service'
  },
  users: {
    url: '//eva.staging.livee.com/users-service'
  },
  usersv3: {
    url: '//eva.staging.livee.com/usersv3-service'
  },
  tags: {
    url: '//eva.staging.livee.com/tags-service'
  },
  invitations_alerts: {
    url: '//eva.staging.livee.com/invitations-alerts-api'
  },
  short: {
    url: '//eva.staging.livee.com/shortener-server'
  },
  phone: {
    url: '//eva.staging.livee.com/phone-number',
    webhook: ''
  },
  emails: {
    url: '//eva.staging.livee.com/emailsv1-service'
  },
  emailsv3: {
    url: '//eva.staging.livee.com/emailsv3-service'
  },
  segments: {
    url: '//eva.staging.livee.com/segments-service'
  },
  stats: {
    url: '//eva.staging.livee.com/stats-service'
  },
  preview: {
    url: '//eva.livee.com/preview-service'
  },
  payment: {
    url: '//eva.staging.livee.com/payment-service'
  },
  google: {
    clientId: '241117617589-l34fpfd2vv66t05c42jbt6jtnavqet8b.apps.googleusercontent.com'
  },
  facebook: {
    clientId: ''
  },
  linkedin: {
    clientId: ''
  },
  screencastCustom: {
    url: '//screencast.livee.com/custom-staging'
  },
  certificates: {
    url: '//eva.staging.livee.com/certificates'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts